import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scrolls to the #hash target after a route change, otherwise to the top. */
const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const attempt = (tries = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (tries < 10) {
          setTimeout(() => attempt(tries + 1), 100);
        }
      };
      attempt();
      return;
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToHash;
